export const timeline = [
  {
    date: "4 月 28 日",
    day: "假期前夜",
    title: "调休安排再度成为话题中心",
    desc: "放假与调休的日历方案在社交平台被反复讨论，「请几天能连休」的拼假攻略热度快速上升，出行平台的搜索量在当晚出现明显峰值。",
    topic: "社交热点",
  },
  {
    date: "4 月 29 日",
    day: "假期首日",
    title: "出行高峰与票务话题同时升温",
    desc: "热门线路的车票、机票与酒店价格成为讨论焦点，围绕「临近出行才订票」的成本差异，网友分享了不少实测经验。",
    topic: "出行消费",
  },
  {
    date: "4 月 30 日",
    day: "假期第二日",
    title: "线下演出与音乐节集中开场",
    desc: "多地音乐节、演唱会进入密集档期，抢票、退票与现场秩序成为演出市场的主要讨论点，相关话题在晚间达到高点。",
    topic: "娱乐动态",
  },
  {
    date: "5 月 1 日",
    day: "劳动节",
    title: "品牌节日营销集中释放",
    desc: "一批品牌在同一时间推出节日 Campaign，其中以「反套路」和「致敬普通劳动者」为切入的创意获得较多正面反馈，也有品牌因文案表达引发争议。",
    topic: "品牌营销",
  },
  {
    date: "5 月 2 日",
    day: "假期中段",
    title: "景区承载与体验话题升温",
    desc: "部分热门景区出现客流集中，排队时长、预约机制与二次消费成为讨论关键词，旅游体验的细节被放大检视。",
    topic: "出行消费",
  },
  {
    date: "5 月 3 日",
    day: "假期后段",
    title: "影视剧口碑出现明显分化",
    desc: "假期档期上映的影片与剧集陆续开分，口碑与票房、播放量的走势出现分歧，「叫好不叫座」与「高开低走」被反复拿来对照。",
    topic: "影视综",
  },
  {
    date: "5 月 4 日",
    day: "青年节",
    title: "平台内容生态话题被集中讨论",
    desc: "短视频与直播平台上，探店、测评与带货内容的真实性问题被集中讨论，用户对「内容与广告的边界」提出了更明确的要求。",
    topic: "社交热点",
  },
  {
    date: "5 月 5 日",
    day: "假期尾声",
    title: "返程高峰与复盘情绪同时到来",
    desc: "返程路线拥堵与高速免费时段成为当天的公开讨论重点，同时各类「假期总结」内容开始集中发布，假期话题进入收尾阶段。",
    topic: "出行消费",
  },
];